/**
 * Scriptures for lesson priest-1. Text from churchofjesuschrist.org; D&C 20 matches scriptures.training.core3.
 */
import type { Scripture } from './scriptures';

export const priest1TrainingScripturesEn: Scripture[] = [
  {
    id: 'dc-20-46-52',
    reference: 'Doctrine and Covenants 20:46–52',
    text:
      'The priest’s duty is to preach, teach, expound, exhort, and baptize, and administer the sacrament, And visit the house of each member, and exhort them to pray vocally and in secret and attend to all family duties. And he may also ordain other priests, teachers, and deacons. And he is to take the lead of meetings when there is no elder present; But when there is an elder present, he is only to preach, teach, expound, exhort, and baptize, And visit the house of each member, exhorting them to pray vocally and in secret and attend to all family duties. In all these duties the priest is to assist the elder if occasion requires.',
    verses: [
      {
        verse: 46,
        text: 'The priest’s duty is to preach, teach, expound, exhort, and baptize, and administer the sacrament,',
      },
      {
        verse: 47,
        text: 'And visit the house of each member, and exhort them to pray vocally and in secret and attend to all family duties.',
      },
      {
        verse: 48,
        text: 'And he may also ordain other priests, teachers, and deacons.',
      },
      {
        verse: 49,
        text: 'And he is to take the lead of meetings when there is no elder present;',
      },
      {
        verse: 50,
        text: 'But when there is an elder present, he is only to preach, teach, expound, exhort, and baptize,',
      },
      {
        verse: 51,
        text: 'And visit the house of each member, exhorting them to pray vocally and in secret and attend to all family duties.',
      },
      {
        verse: 52,
        text: 'In all these duties the priest is to assist the elder if occasion requires.',
      },
    ],
    context: 'Priest duties: teach, sacrament, visits, and supporting the elder.',
  },
  {
    id: '3-nephi-18-1-7',
    reference: '3 Nephi 18:1–7',
    text:
      'And it came to pass that Jesus commanded his disciples that they should bring forth some bread and wine unto him. And while they were gone for bread and wine, he commanded the multitude that they should sit themselves down upon the earth. And when the disciples had come with bread and wine, he took of the bread and brake and blessed it; and he gave unto the disciples and commanded that they should eat. And when they had eaten and were filled, he commanded that they should give unto the multitude. And when the multitude had eaten and were filled, he said unto the disciples: Behold there shall one be ordained among you, and to him will I give power that he shall break bread and bless it and give it unto the people of my church, unto all those who shall believe and be baptized in my name. And this shall ye always observe to do, even as I have done, even as I have broken bread and blessed it and given it unto you. And this shall ye do in remembrance of my body, which I have shown unto you. And it shall be a testimony unto the Father that ye do always remember me. And if ye do always remember me ye shall have my Spirit to be with you.',
    verses: [
      {
        verse: 1,
        text: 'And it came to pass that Jesus commanded his disciples that they should bring forth some bread and wine unto him.',
      },
      {
        verse: 2,
        text: 'And while they were gone for bread and wine, he commanded the multitude that they should sit themselves down upon the earth.',
      },
      {
        verse: 3,
        text: 'And when the disciples had come with bread and wine, he took of the bread and brake and blessed it; and he gave unto the disciples and commanded that they should eat.',
      },
      {
        verse: 4,
        text: 'And when they had eaten and were filled, he commanded that they should give unto the multitude.',
      },
      {
        verse: 5,
        text: 'And when the multitude had eaten and were filled, he said unto the disciples: Behold there shall one be ordained among you, and to him will I give power that he shall break bread and bless it and give it unto the people of my church, unto all those who shall believe and be baptized in my name.',
      },
      {
        verse: 6,
        text: 'And this shall ye always observe to do, even as I have done, even as I have broken bread and blessed it and given it unto you.',
      },
      {
        verse: 7,
        text: 'And this shall ye do in remembrance of my body, which I have shown unto you. And it shall be a testimony unto the Father that ye do always remember me. And if ye do always remember me ye shall have my Spirit to be with you.',
      },
    ],
    context: 'The sacrament among the Nephites: bread, wine, and remembering the Savior.',
  },
  {
    id: 'dc-84-33-39',
    reference: 'Doctrine and Covenants 84:33–39',
    text:
      'For whoso is faithful unto the obtaining these two priesthoods of which I have spoken, and the magnifying their calling, are sanctified by the Spirit unto the renewing of their bodies. They become the sons of Moses and of Aaron and the seed of Abraham, and the church and kingdom, and the elect of God. And also all they who receive this priesthood receive me, saith the Lord; For he that receiveth my servants receiveth me; And he that receiveth me receiveth my Father; And he that receiveth my Father receiveth my Father’s kingdom; therefore all that my Father hath shall be given unto him. And this is according to the oath and covenant which belongeth to the priesthood.',
    verses: [
      {
        verse: 33,
        text: 'For whoso is faithful unto the obtaining these two priesthoods of which I have spoken, and the magnifying their calling, are sanctified by the Spirit unto the renewing of their bodies.',
      },
      {
        verse: 34,
        text: 'They become the sons of Moses and of Aaron and the seed of Abraham, and the church and kingdom, and the elect of God.',
      },
      {
        verse: 35,
        text: 'And also all they who receive this priesthood receive me, saith the Lord;',
      },
      {
        verse: 36,
        text: 'For he that receiveth my servants receiveth me;',
      },
      {
        verse: 37,
        text: 'And he that receiveth me receiveth my Father;',
      },
      {
        verse: 38,
        text: 'And he that receiveth my Father receiveth my Father’s kingdom; therefore all that my Father hath shall be given unto him.',
      },
      {
        verse: 39,
        text: 'And this is according to the oath and covenant which belongeth to the priesthood.',
      },
    ],
    context: 'Priesthood, sanctification, and covenant: receiving the Lord and the Father.',
  },
];
